// Centralised configuration constants

export const STORAGE_KEYS = {
  ID_TOKEN: 'iflow_id_token',
  ACCESS_TOKEN: 'iflow_access_token',
  REFRESH_TOKEN: 'iflow_refresh_token',
} as const;

export const API_CONFIG = {
  TIMEOUT_MS: 30_001,
  DEFAULT_REGION: 'ap-southeast-2',
} as const;

export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  BROWSE_PAGE_SIZE: 50,
  CONNECTIONS_LIMIT: 10,
} as const;

export const AUTH_CONFIG = {
  DEFAULT_ROLE: 'inventor',
  MFA_CODE_LENGTH: 6,
} as const;
